import LocationOperationsComponent from "../components/location-operations.component";

export default function LocationOperationsPage() {
  return (
    <div>
      <LocationOperationsComponent />
    </div>
  );
}
